// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__2otSh","logo":"Header_logo__2yYRj","loggedin":"Header_loggedin__b2-j5","nav":"Header_nav__1k-0_","nav_list":"Header_nav_list__9TWO2"};